import * as React from 'react';
import './style.css';

export type ButtonProperties = [string, (() => void) | null];

export default class ModalDialog extends React.Component<{
  title: string,
  buttons?: ButtonProperties[],
  className?: string,
  bodyPadding?: string,
  hidden?: boolean,
  hideDialog: () => void,
}> {
  render() {
    const { buttons, hideDialog } = this.props;

    const className = [
      'modal-dialog',
      ...(this.props.hidden ? ['hidden'] : []),
      ...(this.props.className ? [this.props.className] : []),
    ].join(' ');

    return (
      <div
        key="dialog-singular"
        className={className}
      >
        <div className="cover" onClick={hideDialog}/>
        <div className="content">
          <div className="dialog-header">
            <div>
              <div>
                <div>
                  <div>{this.props.title}</div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="dialog-body"
            style={(
              'bodyPadding' in this.props ?
              { padding: this.props.bodyPadding } :
              {}
            )}
          >
            {this.props.children}
          </div>
          {(() => {
            if (!buttons || buttons.length === 0) {
              return [];
            }

            return (
              <div className="dialog-footer">
                {buttons.map((btn => {
                  const [text, fn] = btn;

                  const className = [
                    'dialog-button',
                    fn ? [] : ['disabled']
                  ].join(' ');

                  return (
                    <div
                      key={text}
                      className={className}
                      style={{ width: `${100 / buttons.length}%` }}
                      onClick={() => fn && fn()}
                    >
                      {text}
                    </div>
                  );
                }))}
              </div>
            );
          })()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/ModalDialog/index.tsx